// extracted by mini-css-extract-plugin
export default {"layout":"headerSideBarLayout_layout__zsjbR"};